exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\r\n/* The flag's img will adapt to the width of the container */\n.pix-flag[data-v-56b7ada6] {\r\n  width: 100%;\n}\r\n", ""]);

// exports
